<template>
  <a-divider :class="bem.b()" v-bind="attrs" :style="computedStyle">
    <ll-icon v-if="prefixIcon" v-bind="prefixIcon" />

    <span v-if="props.content" :style="{ color: textColor }">
      {{ props.content }}
    </span>
    <slot v-else></slot>

    <ll-icon v-if="suffixIcon" v-bind="suffixIcon" />
  </a-divider>
</template>

<script lang="ts" setup>
import { createNamespace } from '@ll-plus/utils'
import { computed, useAttrs } from 'vue'
import { dividerProps } from './divider'

// 1.defineOptions
defineOptions({
  name: 'LlDivider',
})
// 定义组件props
const props = defineProps(dividerProps)

const bem = createNamespace('divider')
const attrs = useAttrs()

const computedStyle = computed(() => ({
  borderColor: props.borderColor,
}))
</script>
